import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Smart domain redirect - only redirect specific production Firebase domains
// Allows: localhost, preview channels, staging, and custom domains
const CUSTOM_DOMAIN = "airtap.co.za";
const currentHostname = window.location.hostname;

// List of Firebase default domains that should redirect to custom domain
const FIREBASE_PRODUCTION_DOMAINS = [
  "airtalent-tap.web.app",
  "airtalent-tap.firebaseapp.com"
];

// Check if current domain should redirect
const shouldRedirect = FIREBASE_PRODUCTION_DOMAINS.includes(currentHostname);

if (shouldRedirect) {
  // Redirect to custom domain, preserving path and query params
  const targetUrl = `https://${CUSTOM_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(targetUrl);
} else {
  // Render the app for all other domains (custom domain, localhost, preview channels, etc.)
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}
